import React from 'react';
import { useI18n } from './i18n';
import { coffeeClass } from './productScoring';

function CoffeeList({ sheets, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (sheets.length === 0) return <div className="empty-state">{t('coffee.list.empty')}</div>;

  return (
    <div className="sheets-list">
      <h2>{t('coffee.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => {
          const total = s.total_score;
          const quality = s.quality_class || coffeeClass(total);
          return (
            <div key={s.id} className="card" onClick={() => onSelect(s)}>
              <div className="card-header">
                <h3>{s.product_name}</h3>
                {s.harvest_year && <span className="vintage">{s.harvest_year}</span>}
              </div>
              <div className="card-body">
                {s.producer && <p>{s.producer}</p>}
                {s.origin && <p className="area">{s.origin}</p>}
                <div className="card-score-final">{total != null ? `${formatNumber(total, 2)}/100` : '—'}</div>
                {quality && <div className={`pairing-badge-sm ${String(quality).replace(/_/g, '-')}`}>{tc('coffee.class', quality)}</div>}
              </div>
              <div className="card-footer">
                {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CoffeeList;
